<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
<ion-loading [isOpen]="loading$ | async"></ion-loading>
